<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import villeData from "@ville/data";
import etablissements from "@ville/places"

export default {
	name: 'app',
	watch: {
		'$route.params.slug': function(slug) {
			if (slug) {
				this.findBySlug(slug)
			}
			else {
				this.$store.commit('setEtablissement', {})
			}
		},
	},
	mounted() {
    	if (this.$route.params && this.$route.params.slug) {
      		this.findBySlug(this.$route.params.slug);
    	}
  	},
	methods: {
		findBySlug(slug) {
			if (etablissements[slug]) {
				this.$store.commit('setEtablissement', etablissements[slug]);
			}

		}
	},
}
</script>

<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
}

h1,
h2,
h3,
h4 {
	font-family: 'Archivo', Helvetica, Arial, sans-serif;
	font-weight: 700;
}
</style>